import { AnalyticsStore } from 'bernie-plugin-mobx';
import { MarkPageUsableOptions } from 'bernie-plugin-mobx/dist/stores/common/analytics-store';
import { PlatformAnalyticsStore } from 'bernie-analytics';

class AnalyticsWrapper {
  private shouldPublishAnalyticsPayload = true;
  private flexibleSearchAnalytics = null;
  private shouldPublishflexibleSearchAnalytics = true;
  private searchResultsAnalytics = null;
  private shouldMarkPageUsable = true;

  private isValidPayload(response): boolean {
    return response && response.extensions && response.extensions.analytics;
  }

  public resetAnalyticsPayLoad(analytics: AnalyticsStore): void {
    analytics.resetAnalyticsForNewPage();
    this.shouldPublishAnalyticsPayload = true;
    this.shouldPublishflexibleSearchAnalytics = true;
    this.shouldMarkPageUsable = false;
    this.flexibleSearchAnalytics = null;
    this.searchResultsAnalytics = null;
  }

  public resetSearchResultsAnalyticsPayLoad(): void {
    PlatformAnalyticsStore.getPlatformAnalytics().getPerformanceMetrics().reset();
    this.shouldPublishAnalyticsPayload = true;
    this.searchResultsAnalytics = null;
  }

  public setFlexibleSearchAnalytics(response) {
    if (this.isValidPayload(response)) {
      this.flexibleSearchAnalytics = response.extensions.analytics;
    }
  }

  public setSearchResultsAnalytics(response) {
    if (this.isValidPayload(response)) {
      this.searchResultsAnalytics = response.extensions.analytics;
      this.shouldMarkPageUsable = true;
    }
  }

  public setAnalyticsPayload(analyticsData) {
    if (analyticsData !== null) {
      this.searchResultsAnalytics = analyticsData;
      this.shouldMarkPageUsable = true;
    }
  }

  public publishSearchAnalyticsPayload(analytics: AnalyticsStore): void {
    if (this.shouldPublishAnalyticsPayload && this.searchResultsAnalytics) {
      if (this.shouldPublishflexibleSearchAnalytics && this.flexibleSearchAnalytics) {
        analytics.publishClientSidePayload([...this.searchResultsAnalytics, ...this.flexibleSearchAnalytics]);
        this.shouldPublishflexibleSearchAnalytics = false;
      } else {
        analytics.publishClientSidePayload(this.searchResultsAnalytics);
      }
      this.shouldPublishAnalyticsPayload = false;
    }
  }

  public publishAnalyticsPayload(response, analytics: AnalyticsStore): void {
    if (this.shouldPublishAnalyticsPayload && this.isValidPayload(response)) {
      const analyticsPayLoad = response.extensions.analytics;

      analytics.publishClientSidePayload(analyticsPayLoad);
      this.shouldPublishAnalyticsPayload = false;
      this.shouldMarkPageUsable = true;
    }
  }

  public markPageUsableIfNeeded(analyticsStore: AnalyticsStore): void {
    if (this.shouldMarkPageUsable) {
      analyticsStore.markPageUsable();
      this.shouldMarkPageUsable = false;
    }
  }

  public markPageUsable(options: MarkPageUsableOptions, analyticsStore: AnalyticsStore): void {
    if (this.shouldMarkPageUsable) {
      options ? analyticsStore.markPageUsable(options) : analyticsStore.markPageUsable();
      this.shouldMarkPageUsable = false;
    }
  }
}

const analyticsWrapper = new AnalyticsWrapper();

export default analyticsWrapper;
